import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const RateRecommendedCandidateLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "RateRecommendedCandidate" */
      './RateRecommendedCandidate.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
